/**
 * 通用验证函数
 */

/**
 * 验证身份证是否正确
 */
function verifyCardNo(sId) {
    var aCity = {
        11: "北京",
        12: "天津",
        13: "河北",
        14: "山西",
        15: "内蒙古",
        21: "辽宁",
        22: "吉林",
        23: "黑龙江",
        31: "上海",
        32: "江苏",
        33: "浙江",
        34: "安徽",
        35: "福建",
        36: "江西",
        37: "山东",
        41: "河南",
        42: "湖北",
        43: "湖南",
        44: "广东",
        45: "广西",
        46: "海南",
        50: "重庆",
        51: "四川",
        52: "贵州",
        53: "云南",
        54: "西藏",
        61: "陕西",
        62: "甘肃",
        63: "青海",
        64: "宁夏",
        65: "新疆",
        71: "台湾",
        81: "香港",
        82: "澳门",
        91: "国外"
    };
    var iSum = 0;
    var info = "";
    if (!/^\d{17}(\d|x)$/i.test(sId)) return "身份证长度或格式错误";
    sId = sId.replace(/x$/i, "a");
    if (aCity[parseInt(sId.substr(0, 2))] == null) return "身份证地区不正确";
    var sBirthday = sId.substr(6, 4) + "-" + Number(sId.substr(10, 2)) + "-" + Number(sId.substr(12, 2));
    var d = new Date(sBirthday.replace(/-/g, "/"));
    if (sBirthday != (d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate())) return "身份证上的出生日期不正确";
    for (var i = 17; i >= 0; i--) iSum += (Math.pow(2, i) % 11) * parseInt(sId.charAt(17 - i), 11);
    if (iSum % 11 != 1) return "身份证号不正确";
    return true;
}

/**
 * 获取出生年月
 */
function getCardNoBirthday(sId) {

    var aCity = {
        11: "北京",
        12: "天津",
        13: "河北",
        14: "山西",
        15: "内蒙古",
        21: "辽宁",
        22: "吉林",
        23: "黑龙江",
        31: "上海",
        32: "江苏",
        33: "浙江",
        34: "安徽",
        35: "福建",
        36: "江西",
        37: "山东",
        41: "河南",
        42: "湖北",
        43: "湖南",
        44: "广东",
        45: "广西",
        46: "海南",
        50: "重庆",
        51: "四川",
        52: "贵州",
        53: "云南",
        54: "西藏",
        61: "陕西",
        62: "甘肃",
        63: "青海",
        64: "宁夏",
        65: "新疆",
        71: "台湾",
        81: "香港",
        82: "澳门",
        91: "国外"
    };
    var iSum = 0;
    var info = "";
    if (!/^\d{17}(\d|x)$/i.test(sId)) return "你输入的身份证长度或格式错误";
    sId = sId.replace(/x$/i, "a");
    if (aCity[parseInt(sId.substr(0, 2))] == null) return "你的身份证地区不正确";
    var sBirthday = sId.substr(6, 4) + "-" + Number(sId.substr(10, 2)) + "-" + Number(sId.substr(12, 2));
    var d = new Date(sBirthday.replace(/-/g, "/"));
    if (sBirthday != (d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate())) return "身份证上的出生日期不正确";
    for (var i = 17; i >= 0; i--) iSum += (Math.pow(2, i) % 11) * parseInt(sId.charAt(17 - i), 11);
    if (iSum % 11 != 1) return "你输入的身份证号不正确";

    return sBirthday;


}

function getBirthdayFromIdCard(idCard) {
    var birthday = "";
    if (idCard != null && idCard != "") {
        if (idCard.length == 15) {
            birthday = "19" + idCard.substr(6, 6);
        } else if (idCard.length == 18) {
            birthday = idCard.substr(6, 8);
        }

        birthday = birthday.replace(/(.{4})(.{2})/, "$1-$2-");
    }

    return birthday;
}
/**
 * 获取性别
 */
function getCardNoSex(sId) {

    var aCity = {
        11: "北京",
        12: "天津",
        13: "河北",
        14: "山西",
        15: "内蒙古",
        21: "辽宁",
        22: "吉林",
        23: "黑龙江",
        31: "上海",
        32: "江苏",
        33: "浙江",
        34: "安徽",
        35: "福建",
        36: "江西",
        37: "山东",
        41: "河南",
        42: "湖北",
        43: "湖南",
        44: "广东",
        45: "广西",
        46: "海南",
        50: "重庆",
        51: "四川",
        52: "贵州",
        53: "云南",
        54: "西藏",
        61: "陕西",
        62: "甘肃",
        63: "青海",
        64: "宁夏",
        65: "新疆",
        71: "台湾",
        81: "香港",
        82: "澳门",
        91: "国外"
    };
    var iSum = 0;
    var info = "";
    if (!/^\d{17}(\d|x)$/i.test(sId)) return "你输入的身份证长度或格式错误";
    sId = sId.replace(/x$/i, "a");
    if (aCity[parseInt(sId.substr(0, 2))] == null) return "你的身份证地区不正确";
    var sBirthday = sId.substr(6, 4) + "-" + Number(sId.substr(10, 2)) + "-" + Number(sId.substr(12, 2));
    var d = new Date(sBirthday.replace(/-/g, "/"));
    if (sBirthday != (d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate())) return "身份证上的出生日期不正确";
    for (var i = 17; i >= 0; i--) iSum += (Math.pow(2, i) % 11) * parseInt(sId.charAt(17 - i), 11);
    if (iSum % 11 != 1) return "你输入的身份证号不正确";

    if (parseInt(sId.charAt(16) / 2) * 2 != sId.charAt(16)) {
        return 0;
    } else {
        return 1;
    }
}

/**
 * 获取年龄
 */
function analyzeIDCard(IDCard) {
    let sexAndAge = {};
    //获取用户身份证号码
    let userCard = IDCard;
    //如果身份证号码为undefind则返回空
    if (!userCard) {
        return sexAndAge;
    }
    //获取性别
    if (parseInt(userCard.substr(16, 1)) % 2 == 1) {
        sexAndAge.sex = '男';
    } else {
        sexAndAge.sex = '女';
    }
    //获取出生年月日
    //userCard.substring(6,10) + "-" + userCard.substring(10,12) + "-" + userCard.substring(12,14);
    let yearBirth = userCard.substring(6, 10);
    let monthBirth = userCard.substring(10, 12);
    let dayBirth = userCard.substring(12, 14);
    //获取当前年月日并计算年龄
    let myDate = new Date();
    let monthNow = myDate.getMonth() + 1;
    let dayNow = myDate.getDay();
    let age = myDate.getFullYear() - yearBirth;
    if (monthNow < monthBirth || (monthNow == monthBirth && dayNow < dayBirth)) {
        age--;
    }
    //得到年龄
    sexAndAge.age = age;
    //返回性别和年龄
    return sexAndAge;
}
function getAge(strBirthday,compareDate) {
    
    var returnAge;
    var strBirthdayArr=strBirthday.split("-");
    var birthYear = strBirthdayArr[0];
    var birthMonth = strBirthdayArr[1];
    var birthDay = strBirthdayArr[2];
    
    var d = new Date(compareDate);
    var nowYear = d.getFullYear();
    var nowMonth = d.getMonth() + 1;
    var nowDay = d.getDate();
    
    if(nowYear == birthYear){
        returnAge = 0;//同年 则为0岁
    }
    else{
        var ageDiff = nowYear - birthYear ; //年之差
        if(ageDiff > 0){
            if(nowMonth == birthMonth) {
                var dayDiff = nowDay - birthDay;//日之差
                if(dayDiff < 0)
                {
                    returnAge = ageDiff - 1;
                }
                else
                {
                    returnAge = ageDiff ;
                }
            }
            else
            {
                var monthDiff = nowMonth - birthMonth;//月之差
                if(monthDiff < 0)
                {
                    returnAge = ageDiff - 1;
                }
                else
                {
                    returnAge = ageDiff ;
                }
            }
        }
        else
        {
            returnAge = -1;//返回-1 表示出生日期输入错误 晚于今天
        }
    }
    
    return returnAge;//返回周岁年龄
}
function getCardNoAge(sId) { }

// 防止注入攻击
function checkData(v) {

    var temp = v;

    v = v.replace(/\\|\/|\.|\'|\"|\<|\>/g, function (str) { return ''; });
    v = trim(v);

    messageDisplay = v.length < temp.length ? false : true;
    message = '请勿输入非法字符!';

    return v;
}

function verifyName(name) {
    let reg = /^[a-zA-Z\.\u4E00-\u9FA5]{2,28}$/;
    return name == undefined || name == '' || reg.test(name);
}
// 验证邮箱
function verifyEmail(email) {
    var reg = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;
    return email == '' || email == undefined || reg.test(email);
}

//验证文本输入框只能输入中文英文数字
function isChinaOrNumbOrLett(s) {
    var regu = "^[0-9a-zA-Z\u4e00-\u9fa5]+$";
    var reg = new RegExp(regu);
    return reg.test(s);
}
// 手机号
function isMobile(val) {
    return /^((\+|00)86)?1[3-9]\d{9}$/.test(val)
}
// excel读取2018/01/01这种时间格式是会将它装换成数字类似于46254.1545151415 numb是传过来的整数数字
function findKey (obj,value,compare) {
	// 匿名函数解决ie不兼容问题
	var compare = (function(a,b){
	    return a === b;
	});
	// 匿名函数解决ie不兼容问题
	return Object.keys(obj).filter(function(k){ // 用filter()方法替代find()方法还是解决ie不兼容问题
	    return compare(obj[k],value);
	});
}
function formatExcelDate (numb) {
  const time = new Date((numb - 1) * 24 * 3600000 + 1)
  time.setYear(time.getFullYear() - 70)
  return new Date(time).Format("yyyy-MM-dd")
}
function spliceParamsUrl(url,body){
	console.log(url,body)
	let paramsArray = [];
	let length= Object.keys(body).length;
	if (length > 0) { //拼接参数
	    Object.keys(body).forEach(key => paramsArray.push(key + '=' + body[key]));
	    if (url.search(/\?/) === -1) {
	        url += '?' + paramsArray.join('&');
	    } else {
	        url += '&' + paramsArray.join('&');
	    }
	}
	return url
}
function identifyText(textvalue,list) {
	var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, a = 0,
	b = textvalue.split("\n"),
	c = new Array;
	for (d = 0; d < b.length; d++) if ("" != b[d].trim()) {
		for (e = "", f = "", g = "", h = "", i = "", j = b[d].split(/\s+/), k = 0; k < j.length; k++) if (l = j[k], " " != l && "" != l) if ("身份证" != l && "护照" != l && "其他" != l) if (18 == l.length && validateIdNumber(l)) if (m = new RegExp("^d{18}$"), m.test(l));
		else {
			if ("" == h && (h = "1", "1" == a && (h = "身份证")), h = h, g = l, n = new Date(l.slice(6, 10), l.slice(10, 12) - 1, l.slice(12, 14)).Format("yyyy-MM-dd"), f = n, o = l.slice(14, 17) % 2 ? "M": "F", "身份证" == h) {
				if ("M" == o) {
					i = "男";
					continue
				}
				i = "女";
				continue
			}
			i = o
		} else {
			if ("M" == l || "F" == l || "男" == l || "女" == l) {
				if ("0" == a) {
					if ("男" == l) {
						i = "M";
						continue
					}
					if ("女" == l) {
						i = "F";
						continue
					}
					i = l;
					continue
				}
				if ("M" == l) {
					i = "男";
					continue
				}
				if ("F" == l) {
					i = "女";
					continue
				}
				i = l;
				continue
			}
			if (p = new RegExp("(^([A-Z]{1}\\d{7}|[A-Z]{1}\\d{8})$)"), p.test(l)) {
				"" == h && (h = "2", "1" == a && (h = "护照")),
				g = l;
				continue
			}
			if (l.indexOf(".") > 0 && (q = l.split("."), 3 == q.length)) {
				f = spliceDate(q[0], q[1], q[2]);
				continue
			}
			if (l.indexOf("\\") > 0 && (q = l.split("\\"), 3 == q.length)) {
				f = spliceDate(q[0], q[1], q[2]);
				continue
			}
			if (r = /^(\d{1,4})(-|\/)(\d{1,2})\2(\d{1,2})$/, r.exec(l) || /^\d{4}\/[0-1]\d\/[0-3]\d$/g.test(l) || 8 == l.length && /^\d+$/.test(l)) {
				if (l.indexOf("-") > 0 && (q = l.split("-"), 3 == q.length)) {
					f = spliceDate(q[0], q[1], q[2]);
					continue
				}
				f = l;
				continue
			}
			if (s = /^(?=.*[a-zA-Z]+)(?=.*[0-9]+)[a-zA-Z0-9]+$/, t = new RegExp("^[0-9]*$"), s.test(l) || t.test(l)) {
				"" == h && (h = "3", "1" == a && (h = "其他")),
				g = l;
				continue
			}
			if (u = /^[\u2E80-\u9FFF]+$/, u.test(l) && "" != e) {
				"" == h && (h = "3", "1" == a && (h = "其他")),
				g = e,
				e = l;
				continue
			}
			if ("" != e) {
				"" == h && (h = "3", "1" == a && (h = "其他")),
				g = l;
				continue
			}
			e = l
		} else "0" == a && (l = "身份证" == l ? "1": "护照" == l ? "2": "3"),
		h = l;
		if (k < j.length - 1 && ("" == e || "" == f || "" == h || "" == g || "" == i)) return alert("第" + (d + 1) + "行读取失败请检查！"),
		c = [],
		void 0;
		if ("" == e) return alert("第" + (d + 1) + "行读取失败请检查！"),
		void 0;
		if (/^\d+$/.test(f) && (f = f.substring(0, 4) + "-" + f.substring(4, 6) + "-" + f.substring(6, 8)), f = new Date(f).Format("yyyy-MM-dd"), r = /^(\d{1,4})(-|\/)(\d{1,2})\2(\d{1,2})$/, !r.test(f)) return alert("第" + (d + 1) + "行读取失败请检查！"),
		void 0;
		// if (!checJGkData(d + 1, g,list)) return;
		// for (v = 0; v < c.length; v++) if (c[v].insuredIdCardNum == g) return alert("第" + (d + 1) + "行已存在,请勿重复插入！"),
		void 0;
		w = new TempMap(e, f, h, g, i),
		c.push(w),
		e = "",
		f = "",
		g = "",
		h = "",
		i = ""
	}
	return c
}
function checJGkData(index, insuredIdCardNum,list) {
    var rowDatas = list;
    for (var rowindex = 0; rowindex < rowDatas.length; rowindex++) {
        if (rowDatas[rowindex].insuredIdCardNum == insuredIdCardNum) {
            return alert("第" + (index) + "行已存在,请勿重复插入！");
            return false;
        }
        break;
    }
    return true;
}
function TempMap(a, b, c, d, e) {
	this.insuredName = a,
	this.birthday = b,
	this.insuredCertificatId = c,
	this.insuredIdCardNum = d,
	this.insuredGender = e
}
function spliceDate(a, b, c) {
	return 1 == a.length && (a = "0" + a),
	1 == b.length && (b = "0" + b),
	new Date(a + "-" + b + "-" + c).Format("yyyy-MM-dd")
}
function validateIdNumber(a) {
	var e, f, g, h, i, j, k, l, m, n, o, p, b = a,
	c = [1, 0, "x", 9, 8, 7, 6, 5, 4, 3, 2],
	d = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
	if (15 != b.length && 18 != b.length) return ! 1;
	if (e = 18 == b.length ? b.substring(0, 17) : b.slice(0, 6) + "19" + b.slice(6, 16), !/^\d+$/.test(e)) return ! 1;
	if (f = e.slice(6, 10), g = e.slice(10, 12) - 1, h = e.slice(12, 14), i = new Date(f, g, h), j = new Date, k = i.getFullYear(), l = i.getMonth(), m = i.getDate(), k != f || l != g || m != h || i > j) return ! 1;
	for (n = 0, o = 0; 17 > n; n++) o += e.charAt(n) * d[n];
	return e += c[o %= 11],
	p = b.toLowerCase(),
	18 == p.length && p != e ? !1 : !0
}
Date.prototype.Format = function(a) {
	var c, b = {
		"M+": this.getMonth() + 1,
		"d+": this.getDate(),
		"h+": this.getHours(),
		"m+": this.getMinutes(),
		"s+": this.getSeconds(),
		"q+": Math.floor((this.getMonth() + 3) / 3),
		S: this.getMilliseconds()
	};
	/(y+)/.test(a) && (a = a.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length)));
	for (c in b) new RegExp("(" + c + ")").test(a) && (a = a.replace(RegExp.$1, 1 == RegExp.$1.length ? b[c] : ("00" + b[c]).substr(("" + b[c]).length)));
	return a
},
module.exports = {
    verifyName: verifyName,
    verifyEmail: verifyEmail,
    verifyCardNo: verifyCardNo,
    getCardNoSex: getCardNoSex,
    getCardNoBirthday: getCardNoBirthday,
    getBirthdayFromIdCard: getBirthdayFromIdCard,
    isMobile: isMobile,
	identifyText:identifyText,
	formatExcelDate:formatExcelDate,
	spliceParamsUrl:spliceParamsUrl,
	findKey:findKey,
	analyzeIDCard:analyzeIDCard,
	getAge:getAge,
}